import { TYPE_IFT_PAYEE } from '../../config';

const addPayee = [
	'copType',
	'name',
	'displayName',
	'sortCode',
	'accountNumber',
	'reference',
	'chapsReference',
	'otherPaymentReference',
	'payeeAddressLine1',
	'payeeCity',
	'payeeCountry',
];
const addInternationalPayee = [
	'internationalPayeeName',
	'displayName',
	'payeeAddressLine1',
	'payeeCity',
	'payeeCountry',
	'iban',
	'internationalAccountNumber',
	'bickOrSwift',
	'clearingCode',
	'bankName',
	'bankAddressLine1',
	'bankCity',
	'bankCountry',
	'paymentReason',
];

export const formSequence = {
	addPayee,
	addInternationalPayee,
	editPayee: addPayee,
	editInternationalPayee: addInternationalPayee,
};
export const initialState = {
	isValid: false,
	showValidation: false,
	message: '',
};

const initState = { ...initialState };

export const paymentsFlowAddPayeeItems = {
	name: initState,
	sortCode: initState,
	accountNumber: initState,
	reference: initState,
	copType: initState,
};

export const defaultAddPayeeItem = {
	...paymentsFlowAddPayeeItems,
};

export const paymentsFlowAddInternationalPayeeItems = {
	internationalPayeeName: initState,
	payeeAddressLine1: initState,
	payeeCity: initState,
	payeeCountry: initState,
};

export const defaultIFTPaymetDetailsItem = {
	date: initState,
	sendAmount: initState,
};
export const defaultAddInternationalPayeeItem = {
	...paymentsFlowAddInternationalPayeeItems,
	displayName: initState,
	payeeAccountType: initState,
	iban: initState,
};

export const defaultEditPayeeItem = (payeeDetails) => {
	const { payeeAccountType, noBicOrSwift } = payeeDetails;
	if (payeeDetails.type === TYPE_IFT_PAYEE) {
		const defaultItems = {
			...paymentsFlowAddInternationalPayeeItems,
			displayName: initState,
		};
		if (payeeAccountType === 'iban') {
			defaultItems.iban = initState;
			return defaultItems;
		}
		if (payeeAccountType === 'accono') {
			if (noBicOrSwift) {
				defaultItems.internationalAccountNumber = initState;
				defaultItems.bankName = initState;
				defaultItems.bankAddressLine1 = initState;
				defaultItems.bankCity = initState;
				defaultItems.bankCountry = initState;
				return defaultItems;
			}
			defaultItems.internationalAccountNumber = initState;
			defaultItems.bickOrSwift = initState;
			return defaultItems;
		}
	}
	return {
		name: initState,
		sortCode: initState,
		accountNumber: initState,
		displayName: initState,
		reference: initState,
	};
};

export const defaultEditPayeeChapsItem = {
	chapsReference: initState,
};
